export const SkinIdentifiers = {
  AeonBlue: "AeonBlue",
  Light: "Light",
  Dark: "Dark",
  HighContrastLight: "HighContrastLight",
  HighContrastDark: "HighContrastDark",
  Mellow: "Mellow"
};

export const SkinNames = {
  AeonBlue: "Aeon Blue",
  Light: "Light",
  Dark: "Dark",
  HighContrastDark: "Dark (High Contrast)",
  HighContrastLight: "Light (High Contrast)",
  Mellow: "Mellow"
};

const createSkin = id => {
  return {
    identifier: id,
    name: SkinNames[id]
  };
};

const skinOptions = [
  createSkin(SkinIdentifiers.AeonBlue),
  createSkin(SkinIdentifiers.Light),
  createSkin(SkinIdentifiers.HighContrastLight),
  createSkin(SkinIdentifiers.Dark),
  createSkin(SkinIdentifiers.HighContrastDark),
  createSkin(SkinIdentifiers.Mellow)
];

export default skinOptions.map(o => {
  return {
    label: o.name,
    value: o.identifier
  };
});
